import { mergeClasses } from '@fluentui/react-components';

import { CardHeaderTextProps } from 'src/ui-models/cardLayout';
import { useCardBackgroundHeaderBlockStyles } from './CardBackgroundHeaderBlock.styles';

interface CardBackgroundHeaderBlockProps extends CardHeaderTextProps {
  className?: string
}

const CardBackgroundHeaderBlock: React.FC<CardBackgroundHeaderBlockProps> = ({ sectionLabel, title, caption, className }) => {
  const styles = useCardBackgroundHeaderBlockStyles();
  const container = mergeClasses('card-background-header-block', styles.titleContainer, className);

  return (
    <div className={container} data-testid="card-background-header-block">
      <span className={styles.caption}>{sectionLabel}</span>
      <span className={styles.title}>{title}</span>
      <span className={styles.caption}>{caption}</span>
    </div>
  );
};

export default CardBackgroundHeaderBlock;
